module.exports = __webpack_public_path__ + "img/volume-down.03afef46.svg";